module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "acknowPage"
  }, [_c('a', {
    attrs: {
      "id": "title1"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Without the help of a few fellow diehard Billerica memorabilia collectors and historians, this work would not have been possible. With gratitude, I recognize the spirit of sharing that these people have brought to the project. In particular, I would like to express my thanks to just a few.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("A good number of these images are provided courtesy of lifelong Billerica resident Tom Paskiewicz, whose postcard collection is among the finest assembled. I have enjoyed the collector’s pursuit with Tom and appreciate his willingness to share his material.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("I also would like to thank the following friends: Joe Campbell, who shared anything and everything he had with me, honoring the community spirit of his ancestors; Anna Mason, who helped me build my own personal collection, shared the stories, love, and spirit that was the essence of the village, and is living history herself; and Paula Jarvis—my old friend—who has, for many years, turned up images that could not have been found anywhere else in the world and shared them gladly with me. Finally, I would like to thank Helen Potter, a longtime artist and teacher, who helped me assemble a few of the best of these images. Her tireless dedication to the preservation of Billerica’s history is only surpassed by her love of others.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Unless otherwise noted, all images are from the author’s collection.")])])])]), _c('a', {
    attrs: {
      "id": "title1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4307574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781439623909_ack01.vue
// module id = 72
// module chunks = 0